package org.zest.insan_360_website.pages.user.credits_layout

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.Input
import com.varabyte.kobweb.silk.components.icons.fa.FaPlus
import com.varabyte.kobweb.silk.components.icons.fa.FaTicketSimple
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text
import org.zest.insan_360_website.components.layouts.*
import org.zest.insan_360_website.components.widgets.*
import org.zest.insan_360_website.data.LanguageSettings
import org.zest.insan_360_website.data.localized
import org.zest.insan_360_website.data.page_states.dashboard.CreditsDashboardState.creditDashStats
import org.zest.insan_360_website.data.page_states.dashboard.CreditsDashboardState.isLoading
import org.zest.insan_360_website.model.PaymentStatus
import org.zest.insan_360_website.utils.buyCredit
import org.zest.insan_360_website.utils.formatToReadableDateJS

const val price = 20.00f //temporary
val linkThickness = 4.px
val linkColor = userPageBorderStrongColor

@OptIn(DelicateApi::class)
@Composable
fun AdminLayout() {
    PageContentBaseCol {
        val breakpoint = rememberBreakpoint()
        Div(
            Modifier
                .gap(1.cssRem)
                .fillMaxWidth()
                .minHeight(50.percent)
                .height(Height.FitContent)
                .toAttrs()
        ) {
            PageContentContainer(
                Modifier
                    .padding(0.px)
                    .border { width(0.px) }
            ) {
                if (breakpoint >= Breakpoint.LG) CreditStatisticsLG()
                else CreditStatistics()
            }
        }
        PageContentContainer(
            Modifier
                .padding(0.px)
                .border {
                    width(0.px)
                }
                .flex(1)
        ) {
            if (breakpoint >= Breakpoint.LG) TransactionsHistoryLG()
            else TransactionsHistory()
        }
    }
}

@Composable
fun TransactionsHistoryLG() {
    FlushedListContainer(flexWeight = 6, { SectionTitle(userDashWordLibrary.credit_purchase_record.localized) }) {
        val sortedTransactions = creditDashStats?.transactions?.sortedByDescending { it.purchaseAt.toEpochMilliseconds() }

        sortedTransactions?.forEachIndexed { index, transaction ->
            FlushedListRowWrapper(index = index) {
                Row(Modifier.fillMaxWidth().gap(0.25.cssRem), verticalAlignment = Alignment.CenterVertically) {
                    Column(Modifier.flex(3), verticalArrangement = Arrangement.Center) {
                        CopyableIdText(transaction.id)
                        TransactionLabel(userDashWordLibrary.id_transaction.localized)
                    }
                    Column(Modifier.flex(3), verticalArrangement = Arrangement.Center) {
                        CopyableIdText(transaction.toyyibpayId)
                        TransactionLabel(userDashWordLibrary.id_toyyib.localized)
                    }
                    Box(Modifier.flex(2).fillMaxSize(), contentAlignment = Alignment.CenterStart) {
                        TransactionStatusBadge(transaction.status)
                    }
                    Column(
                        Modifier.flex(1),
                        verticalArrangement = Arrangement.Center,
                        horizontalAlignment = Alignment.End
                    ) {
                        SpanText(
                            transaction.purchasedAmount.toString(),
                            Modifier.fontSize(0.875.cssRem),
                        )
                        TransactionLabel(userDashWordLibrary.credit.localized, TextAlign.End)
                    }
                    Column(
                        Modifier.flex(2),
                        verticalArrangement = Arrangement.Center,
                        horizontalAlignment = Alignment.End
                    ) {
                        TransactionAmountDisplay(transaction.amountPaidCents)
                        TransactionLabel(userDashWordLibrary.total.localized, TextAlign.End)
                    }
                    Column(
                        Modifier.flex(3),
                        verticalArrangement = Arrangement.Center,
                        horizontalAlignment = Alignment.End
                    ) {
                        SpanText(
                            formatToReadableDateJS(transaction.purchaseAt),
                            Modifier.fontSize(0.875.cssRem)
                        )
                        TransactionLabel(userDashWordLibrary.time_transaction.localized, TextAlign.End)
                    }
                }
            }
        }
    }
}

@Composable
fun TransactionsHistory() {
    FlushedListContainer(flexWeight = 8, { SectionTitle(userDashWordLibrary.credit_purchase_record.localized) }) {
        val sortedTransactions =
            creditDashStats?.transactions?.sortedByDescending { it.purchaseAt.toEpochMilliseconds() }

        sortedTransactions?.forEachIndexed { index, transaction ->
            FlushedListRowWrapper(gap = 0.25.cssRem, index = index, Modifier.gap(1.cssRem)) {
                Row(
                    Modifier
                        .fillMaxWidth()
                        .justifyContent(JustifyContent.SpaceBetween)
                        .gap(0.5.cssRem)
                ) {
                    Column(Modifier.flex(3).padding(right = 0.5.cssRem), verticalArrangement = Arrangement.Center) {
                        CopyableIdText(transaction.id)
                        TransactionLabel(userDashWordLibrary.id_transaction.localized)
                    }
                    Column(
                        Modifier.flex(1),
                        verticalArrangement = Arrangement.Center,
                        horizontalAlignment = Alignment.End
                    ) {
                        TransactionStatusBadge(transaction.status)
                    }
                }
                Row(Modifier.fillMaxWidth()) {
                    Column(
                        Modifier.fillMaxWidth().padding(right = 0.5.cssRem),
                        verticalArrangement = Arrangement.Center
                    ) {
                        CopyableIdText(transaction.toyyibpayId)
                        TransactionLabel(userDashWordLibrary.id_toyyib.localized)
                    }
                    Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.Center) {
                        TransactionAmountDisplay(transaction.amountPaidCents)
                        TransactionLabel(userDashWordLibrary.total.localized)
                    }
                    Box(Modifier.fillMaxWidth().flex(1))
                }
                Row(Modifier.fillMaxWidth()) {
                    Column(
                        Modifier.fillMaxWidth(),
                        verticalArrangement = Arrangement.Center
                    ) {
                        SpanText(
                            formatToReadableDateJS(transaction.purchaseAt),
                            Modifier.fontSize(0.875.cssRem)
                        )
                        TransactionLabel(userDashWordLibrary.time_transaction.localized)
                    }
                    Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.Center) {
                        SpanText(
                            transaction.purchasedAmount.toString(),
                            Modifier.fontSize(0.875.cssRem)
                        )
                        TransactionLabel(userDashWordLibrary.credit.localized)
                    }
                }
            }
        }
    }
}

@Composable
private fun TransactionLabel(text: String, textAlign: TextAlign = TextAlign.Start) {
    SpanText(
        text,
        Modifier
            .fontSize(0.875.cssRem)
            .fontWeight(FontWeight.Medium)
            .color(userPageSecondaryTextColor)
            .textAlign(textAlign)
    )
}

@Composable
private fun TransactionStatusBadge(status: PaymentStatus) {
    val displayStatus = if (status == PaymentStatus.PENDING) PaymentStatus.FAILED else status

    val statusColor = when (displayStatus) {
        PaymentStatus.PAID -> Color.rgb(0x16a34a)
        else -> Color.rgb(0xdc2626)
    }

    StatusBadge(
        text = userDashWordLibrary.paymentStatus[displayStatus]?.localized ?: when(displayStatus) {
            PaymentStatus.PAID -> "PAID"
            else -> "FAILED"
        },
        color = statusColor
    )
}

@Composable
private fun TransactionAmountDisplay(cents: Int) {
    val dollars = cents / 100
    val remainder = cents % 100
    val formattedAmount = "$dollars.${remainder.toString().padStart(2, '0')}"
    Row(Modifier.gap(0.125.cssRem), verticalAlignment = Alignment.Bottom) {
        SpanText(
            "RM",
            Modifier
                .fontSize(0.7.cssRem)
                .color(userPageSecondaryTextColor)
        )
        SpanText(formattedAmount, Modifier.fontSize(0.875.cssRem))
    }
}

@Composable
private fun CreditStatistics() {
    Column(Modifier.fillMaxSize().gap(0.5.cssRem)) {
        SectionTitle(userDashWordLibrary.organization_credit_calculation.localized) {
            FaTicketSimple(Modifier.rotate(25.deg).translate(tx = 0.px, ty = 0.px), IconSize.X1)
        }
        Column(Modifier.fillMaxSize().flex(8)) {
            Row(Modifier.fillMaxSize().flex(10)) {
                CreditDetailedStatContainer(userDashWordLibrary.total.localized, creditDashStats?.creditStats?.total.toString()) {
                    AddCreditButton()
                }
                HorizontalLink()
                CreditDetailedStatContainer(userDashWordLibrary.expired.localized, creditDashStats?.creditStats?.expired.toString())
            }
            VerticalLink()
            Row(Modifier.fillMaxSize().flex(10)) {
                CreditDetailedStatContainer(userDashWordLibrary.active.localized, creditDashStats?.creditStats?.active.toString())
                HorizontalLink()
                CreditDetailedStatContainer(
                    userDashWordLibrary.unassigned.localized,
                    creditDashStats?.creditStats?.active?.minus(creditDashStats?.creditStats?.assigned ?: 0).toString()
                )
            }
            VerticalLink()
            Row(Modifier.fillMaxSize().flex(6)) {
                CreditDetailedStatContainer(userDashWordLibrary.assigned.localized, creditDashStats?.creditStats?.assigned.toString())
                HorizontalLink()
                CreditDetailedStatContainer(userDashWordLibrary.used.localized, creditDashStats?.creditStats?.used.toString())
            }
        }
    }
}

@Composable
private fun CreditStatisticsLG() {
    Column(Modifier.fillMaxSize().gap(0.5.cssRem)) {
        SectionTitle(userDashWordLibrary.organization_credit_calculation.localized) {
            FaTicketSimple(Modifier.rotate(25.deg).translate(tx = 0.px, ty = 0.px), IconSize.X1)
        }
        Row(Modifier.fillMaxSize().flex(6)) {
            Column(Modifier.fillMaxHeight().flex(10)) {
                CreditDetailedStatContainer(userDashWordLibrary.total.localized, creditDashStats?.creditStats?.total.toString()) {
                    AddCreditButton()
                }
                VerticalLinkLG()
                CreditDetailedStatContainer(userDashWordLibrary.expired.localized, creditDashStats?.creditStats?.expired.toString())
            }
            HorizontalLinkLG()
            Column(Modifier.fillMaxHeight().flex(10)) {
                CreditDetailedStatContainer(userDashWordLibrary.active.localized, creditDashStats?.creditStats?.active.toString())
                VerticalLinkLG()
                CreditDetailedStatContainer(
                    userDashWordLibrary.unassigned.localized,
                    creditDashStats?.creditStats?.active?.minus(creditDashStats?.creditStats?.assigned ?: 0).toString()
                )
            }
            HorizontalLinkLG()
            Column(Modifier.fillMaxHeight().flex(10)) {
                CreditDetailedStatContainer(userDashWordLibrary.assigned.localized, creditDashStats?.creditStats?.assigned.toString())
                VerticalLinkLG()
                CreditDetailedStatContainer(userDashWordLibrary.used.localized, creditDashStats?.creditStats?.used.toString())
            }
        }
    }
}

@Composable
private fun AddCreditButton() {
    val modal = LocalModal.current
    val toast = LocalToast.current

    Box(
        Modifier
            .position(Position.Absolute)
            .left(1.cssRem)
            .bottom(1.cssRem)
            .zIndex(1)
            .borderRadius(99.px)
            .aspectRatio(1)
            .fontSize(1.5.cssRem)
            .padding(0.5.cssRem)
            .onClick { modal.show { BuyBulkCreditModal(toast, modal) } }
            .then(contentButtonStyle.toModifier()),
        contentAlignment = Alignment.Center
    ) {
        FaPlus(Modifier.color(userPageBGColor))
    }
}

@Composable
private fun CreditDetailedStatContainer(title: String, stat: String, extraElement: @Composable () -> Unit = {}) {
    PageContentContainer(
        Modifier
            .flex(4)
            .border(style = LineStyle.Solid, width = 1.px, color = userPageBorderStrongColor)
            .borderRadius(2.cssRem)
            .padding {
                top(1.cssRem)
                bottom(1.cssRem)
                left(1.cssRem)
                right(1.5.cssRem)
            }
            .position(Position.Relative)
            .then(containerShadowStyle.toModifier())
    ) {
        extraElement()
        Column(Modifier.fillMaxSize()) {
            Box(Modifier.flex(2).fontSize(0.85.cssRem)) {
                SpanText(
                    title,
                    Modifier
                        .fontWeight(FontWeight.Bold)
                        .fontSize(1.5.cssRem)
                        .color(userPageSecondaryTextColor)
                )
            }
            Box(
                Modifier
                    .flex(3)
                    .fontSize(1.5.cssRem)
                    .fillMaxWidth(),
                contentAlignment = Alignment.BottomEnd
            ) {
                if (isLoading) DotLoading()
                else SpanText(
                    stat,
                    Modifier
                        .fontWeight(FontWeight.Bolder)
                        .fontSize(2.cssRem)
                )
            }
        }
    }
}

@OptIn(DelicateApi::class)
@Composable
private fun BuyBulkCreditModal(toast: ToastState, modal: ModalState) {
    var isProcessing by remember { mutableStateOf(false) }
    var counter by remember { mutableStateOf(1) }
    val scope = rememberCoroutineScope()
    val breakpoint = rememberBreakpoint()
    val isMobile = breakpoint < Breakpoint.SM
    val bulkCreditModalLocalized = LanguageSettings.UserDashboardPage.BulkPurchaseModal

    Column(
        Modifier
            .fillMaxWidth()
            .padding(if (isMobile) 0.5.cssRem else 1.5.cssRem)
            .gap(1.5.cssRem)
            .userSelect(UserSelect.None),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Column(
            Modifier.fillMaxWidth().gap(0.5.cssRem),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(
                bulkCreditModalLocalized.title.localized,
                Modifier
                    .fontSize(1.5.cssRem)
                    .fontWeight(FontWeight.Bold)
                    .color(userPagePrimaryTextColor)
                    .textAlign(TextAlign.Center)
            )
            SpanText(
                bulkCreditModalLocalized.sub.localized,
                Modifier
                    .fontSize(0.85.cssRem)
                    .fontWeight(FontWeight.Medium)
                    .color(userPageSecondaryTextColor)
                    .textAlign(TextAlign.Center)
            )
        }

        Row(
            Modifier
                .fillMaxWidth()
                .backgroundColor(userPageBGColor)
                .border {
                    width(1.px)
                    color(userPageBorderStrongColor)
                    style(LineStyle.Solid)
                }
                .borderRadius(0.5.cssRem)
                .padding(topBottom = 1.cssRem, leftRight = 0.5.cssRem)
                .fontSize(1.25.cssRem)
                .fontWeight(FontWeight.Bold)
                .color(userPagePrimaryTextColor)
                .flexWrap(FlexWrap.Wrap)
                .gap(0.5.cssRem),
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically
        ) {
            SpanText(bulkCreditModalLocalized.purchase.localized)

            Input(
                modifier = baseInputStyle.toModifier()
                    .textAlign(TextAlign.Center)
                    .width(Width.FitContent),
                type = InputType.Number,
                value = counter,
                onValueChange = { newCounter -> counter = newCounter?.toInt()?.coerceIn(0, 100) ?: 0 }
            )

            SpanText("${ bulkCreditModalLocalized.credit.localized } = RM${(counter * price).toInt()}")
        }

        Button(
            enabled = !isProcessing,
            onClick = {
                if (isProcessing) return@Button
                buyCredit(toast, modal, scope, amount = counter) { processing ->
                    isProcessing = processing
                }
            },
            modifier = Modifier
                .fillMaxWidth()
                .minHeight(3.cssRem)
                .fontSize(1.cssRem)
                .fontWeight(FontWeight.Bold)
        ) {
            Text(
                if (isProcessing) "Connecting to Bank Gateway..."
                else bulkCreditModalLocalized.pay_with_fpx.localized
            )
        }
    }
}

@Composable
private fun VerticalLinkLG() {
    Box(Modifier.fillMaxWidth().flex(1), contentAlignment = Alignment.Center) {
        Box(
            Modifier
                .fillMaxHeight()
                .minHeight(2.cssRem)
                .width(linkThickness)
                .backgroundColor(linkColor)
        )
    }
}

@Composable
private fun VerticalLink() {
    Row(Modifier.fillMaxWidth().flex(1)) {
        Box(Modifier.flex(5).fillMaxHeight(), contentAlignment = Alignment.Center) {
            Box(
                Modifier
                    .fillMaxHeight()
                    .minHeight(1.5.cssRem)
                    .width(linkThickness)
                    .backgroundColor(linkColor)
            )
        }
        Box(Modifier.flex(1).fillMaxHeight())
        Box(Modifier.flex(5).fillMaxHeight())
    }
}

@Composable
private fun HorizontalLinkLG() {
    Column(Modifier.fillMaxHeight().flex(1)) {
        Box(Modifier.fillMaxSize().flex(5), contentAlignment = Alignment.Center) {
            Box(Modifier.fillMaxWidth().height(linkThickness).backgroundColor(linkColor)) {}
        }
        Box(Modifier.fillMaxWidth().flex(1))
        Box(Modifier.fillMaxWidth().flex(5))
    }
}

@Composable
private fun HorizontalLink() {
    Column(
        Modifier.fillMaxHeight().flex(1),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Box(Modifier.fillMaxWidth().height(linkThickness).backgroundColor(linkColor)) {}
    }
}